import Filter from '../filter'

export default class Notification {
  constructor(transfer, filter) {
    this.filter = filter
    this.transfer = transfer
    this.name = 'Notification'
    this.channelName = null
    this.buildFilter = this.buildFilter.bind(this)
  }

  get isFrontendCompatible() {
    // Determines if the notification should be editable from this interface.
    return Boolean(this.friendlyChannelName)
  }

  get friendlyChannelName() {
    return Filter.channelOptions[this.channelName]
  }

  get filterSignature() {
    return {
      transferId: this.transfer.id,
      stepId: this.attachedStepId
    }
  }

  get filterExpirationTime() {
    const expirationTime = this.transfer.startTime.add(7, 'days')
    return expirationTime.toISOString()
  }

  buildFilter() {
    const filter = Filter.one({
      channelName: this.channelName,
      eventId: this.filterEventId,
      expirationTime: this.filterExpirationTime,
      message: this.message,
      predicateConfigs: this.predicateConfigs,
      signature: this.filterSignature
    })
    if (this.filter) {
      filter.id = this.filter.id
    }
    return filter
  }
}
